/** The signed-in shell's rail (AppRail) and its ⌘K canvas search palette. */
export const rail = {
  navigation: 'Navigation',
  showSidebar: 'Show sidebar',
  hideSidebar: 'Hide sidebar',
  searchCanvasesShortcut: 'Search canvases (⌘K)',
  allCanvases: 'All canvases',
  ownedByMe: 'Owned by me',
  sharedWithMe: 'Shared with me',
  workspaces: 'Workspaces',
  newWorkspace: 'New workspace',
  createWorkspace: 'Create workspace',
  noPlanYet: 'No plan yet',
  explore: 'Explore',
  community: 'Community',
  resources: 'Resources',
  automations: 'Automations',
  integrations: 'Integrations',
  agents: 'Agents',
  agentCanvases: { one: '{count} canvas', other: '{count} canvases' },
  workingNow: 'working right now',
  connectAgent: 'Connect an agent',

  searchCanvases: 'Search canvases',
  results: 'Results',
  noMatch: 'No canvas matches “{query}”.',
  frameCount: { one: '{count} frame', other: '{count} frames' },
  edited: 'edited {time}',
  sharedWithYou: 'shared with you',
} as const
